import { Box, Menu, MenuItem } from '@atgfr8/atg-ui-tailwind';
import { MenuDownIcon } from '@atgfr8/icons';
import { Button, ToastType } from '@components';
import {
  copyShipperUrl,
  disableTracking,
  enableTracking,
  orderStore,
  TrackingProviders,
} from '@store/orders';
import { TrackingDataPayload } from '@typeDefinitions/loadTypes';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { timeZoneAbbreviation } from '@utils/dateFormat';
import { handleToast } from '@utils/utils';
import {
  trackingOptions,
  truckerToolsTrackingOptions,
} from '@views/order/constants';
import { Component, createEffect, createSignal, For } from 'solid-js';
import { CHANGE_TRACKING_SOURCES } from '@changeTracking/utils/changeTrackingRegistry';

import classes from './classes';

const StopsTracking: Component = () => {
  const [buttonRef, setButtonRef] = createSignal<HTMLButtonElement>();
  const [isTruckerToolsTrackingEnabled, setIsTruckerToolsTrackingEnabled] =
    createSignal(false);

  createEffect(() => {
    const loadId = orderStore.order.loads[orderStore.activeTab.index]?.id;

    if (!loadId) {
      setIsTruckerToolsTrackingEnabled(false);
      return;
    }

    const trackingServiceId =
      orderStore.order.loads[orderStore.activeTab.index]?.trackingServiceId;

    if (
      trackingServiceId &&
      trackingServiceId === TrackingProviders.TruckerTools
    ) {
      setIsTruckerToolsTrackingEnabled(true);
    } else {
      setIsTruckerToolsTrackingEnabled(false);
    }
  });

  const serviceId =
    orderStore.order.loads[orderStore.activeTab.index]?.trackingServiceId;

  const initialTrackingValues = {
    driverPhone:
      orderStore.order.loads[orderStore.activeTab.index]?.driverPhoneNumber,
    loadId: orderStore.order.loads[orderStore.activeTab.index]?.id,
    trackingStartDate: new Date().toISOString(),
    settings: {
      truckNumber: '',
      trailerNumber: '',
      timezone: timeZoneAbbreviation(),
      resend: true,
    },
    trackingStopWindows:
      orderStore.order.loads[orderStore.activeTab.index]?.stops?.map((val) => {
        return { Id: val.id, EDT: '', ETA: '' };
      }) || [],
    serviceId: serviceId === null ? 0 : serviceId,
  };

  const handleTracking = async (trackingOption: string) => {
    try {
      const { id } = orderStore.order.loads[orderStore.activeTab.index];
      if (trackingOption === 'Disable') {
        await disableTracking(
          id,
          CHANGE_TRACKING_SOURCES.orderDetails.stopsDisableTracking,
        );
      } else if (trackingOption === 'Resend') {
        const resp = await enableTracking(
          initialTrackingValues as unknown as TrackingDataPayload,
          CHANGE_TRACKING_SOURCES.orderDetails.stopsResendTrackingInstallation,
        );

        if (resp) {
          handleToast(ToastType.Success, resp.message);
        }
      } else if (trackingOption === 'CopyShipperUrl') {
        await copyShipperUrl(id);
      }
    } catch (error) {
      handleToast(ToastType.Error, (error as Error).message);
    }
  };

  return (
    <Box class="flex justify-center">
      <span ref={setButtonRef}>
        <Button
          label="Tracking Options"
          class={classes.stopsTrackingButton}
          endIcon={<MenuDownIcon size={20} />}
          disabled={orderStore.isReadOnly}
          size="sm"
          sx={{ 'line-height': '22px' }}
          dataTestId={formatDataTestId('Tracking Options', 'button')}
        />
      </span>
      <Menu anchorEl={buttonRef}>
        <For
          each={
            isTruckerToolsTrackingEnabled()
              ? truckerToolsTrackingOptions
              : trackingOptions
          }
        >
          {(item) => (
            <MenuItem
              class="text-[rgba(0,0,0,0.87)] text-base! font-normal whitespace-nowrap"
              onClick={() => {
                void handleTracking(item.value);
              }}
            >
              <span class="inline-flex items-center justify-center h-[22px] w-[36px] align-middle">
                <img src={item.icon} />
              </span>{' '}
              {item.label}
            </MenuItem>
          )}
        </For>
      </Menu>
    </Box>
  );
};

export default StopsTracking;
